import * as React from 'react';
import {FunctionComponent} from 'react';
import {GraphPillDto} from '../swagger';
import {formatDateTime} from '../helpers/helpers';
import {TrendView} from './TrendView';
import {AppRoutes} from '../routing/AppRoutes';
import {Link} from 'react-router-dom';
import {ErrorsChartElementState} from './ErrorsChartElementState';
import {observer} from 'mobx-react-lite';
import {Spinner} from './Spinner';
import {errorChartElementStates} from './ErrorsChart';
import classNames from 'classnames';

export interface ErrorsChartElementProps {
    pillData: GraphPillDto;
    logsIds: string[];
    state: ErrorsChartElementState;
    blink?: boolean;
    small?: boolean;
}

export const ErrorsChartElement: FunctionComponent<ErrorsChartElementProps> = observer((
    {pillData, logsIds, state, blink, small}) => {
    const severity = pillData.severity ?? 'None';
    const popupAvailable = pillData.severity !== undefined;
    return (
        <div
            data-key={pillData.key!}
            className={classNames(['show-fade', 'errors-chart-item', severity, {'blink30s': blink}, {'errors-chart-item-small': small}])}
            onMouseEnter={() => {
                if (popupAvailable) {
                    const active = Array.from(errorChartElementStates.values()).find(x => x.showDetails);
                    if (active) {
                        active.setShowDetails(false);
                        if (active.hideTimeout) {
                            clearTimeout(active.hideTimeout);
                        }
                    }

                    state.setShowDetails(true);
                    state.loadItems(logsIds);
                }
            }}
            onMouseLeave={() => state.hideDetailsWithTimeout()}
        >
            {popupAvailable && state.showDetails && (
                <React.Fragment>
                    <div className={`triangle border-${severity}`}/>
                    <div className="triangle-gray"/>
                    <div className={`show-fade errors-chart-item-details border-${severity}`}>

                        {state.isLoading && <Spinner/>}
                        {state.items.map((el) => (
                            <div key={el.flatId + 'graphid'}>
                                <div className="flat-list-title" title={el.message || ''}>
                                    <span className="mr-3 truncate whitespace-nowrap">{el.message}</span>
                                    <span
                                        className="badge mr-2 right-0 text-sm"
                                        style={{right: '-1rem'}}
                                        title={'Count: ' + el.count}
                                    >
                                        {el.count}
                                    </span>
                                    <TrendView imgHeight={'17.6px'} trend={el.trend}/>
                                </div>
                                {' '}
                                <div className="mb-2 text-m-gray-6">
                                    <span title={'First time seen'}>{formatDateTime(el.firstTimeSeen)}</span>
                                    &nbsp;&gt;&nbsp;
                                    <span title={'Last time seen'}>{formatDateTime(el.lastTimeSeen)}</span>
                                </div>
                                <div className="flex items-center">
                                    <span className={`flat-list-item-bullet mr-3 relative top-auto ${el.severity}`}/>
                                    <span className={'mr-auto text-' + el.severity}>{el.severity}</span>
                                    <Link
                                        className="btn btn-secondary text-sm"
                                        to={`${AppRoutes.LogOverview}/${el.logId}/${el.flatId}`}
                                    >
                                        Open
                                    </Link>
                                </div>
                            </div>
                        ))}

                        {state.items.length === 20 && <div>Showing only last 20 in that interval</div>}
                    </div>
                </React.Fragment>
            )}
        </div>
    );
});
